// @flow

import sortBy from 'lodash/sortBy';

import { reduxDB } from './reduxDB';
import { InvoiceStorage } from '../screens/Cart/helpers';
import type { InvoiceType, LodgeOrderData, LodgeOrderType } from '../types/invoices';
import { createOrder, createInvoice, fetchInvoice } from '../services/cart';

type OrderIdsType = Array<string>;
type LodgesOrder = {
  lodges: Array<LodgeOrderData>
}

// ----------------------------------------
//  SELECTORS
// ----------------------------------------

const getInvoice = (db: any): InvoiceType => db.invoice.get();

const getOrderIds = (db: any): OrderIdsType => db.orders.allIds();

const getOrderByIdAndType = (db: any, deps: mixed[]): LodgeOrderType | null => {
  const [id, type] = deps;
  const order = db.orders.get(id);
  
  return order.itemType === type ? order : null;
};

const getCartData = (db: any) => {
  const invoice: InvoiceType = getInvoice(db);
  const orderIds: OrderIdsType = getOrderIds(db);

  return [invoice, orderIds];
};

// ----------------------------------------
//  ACTIONS
// ----------------------------------------

type InvoiceLineItemsType = {
  invoice: InvoiceType,
  lineItems: Array<LodgeOrderType>,
};

const updateCart = (invoiceWithLineItems: InvoiceLineItemsType) => {
  const { invoice, lineItems } = invoiceWithLineItems;

  reduxDB.invoice.update(invoice);
  reduxDB.orders.populate(sortBy(lineItems, o => o.itemData.checkinDate));
};

const addToCart = async (data: LodgesOrder) => {
  const invoiceId = InvoiceStorage.get();
  const isInvoiceAlreadyCreated = Boolean(invoiceId);

  if (isInvoiceAlreadyCreated) {
    const cartData = await createOrder(invoiceId, data);
    updateCart(cartData);
  } else {
    const invoiceId = await createInvoice(data);
    InvoiceStorage.set(invoiceId);
    const cartData = await fetchInvoice(invoiceId);
    updateCart(cartData);
  }
};

export {
  getInvoice,
  getOrderIds,
  getOrderByIdAndType,
  getCartData,

  updateCart,
  addToCart,
};



// WEBPACK FOOTER //
// ./src/redux/cart.js